/* STAYD PDP — pack selector, carousels, orbit. No dependencies. */
(function () {
  var BUILD = 87;
  try { console.info('STAYD PDP build ' + BUILD + ' — start'); } catch (e) {}
  function init(root) {
    if (root.__staydInit) return;
    root.__staydInit = true;
    var form = root.querySelector('[data-stayd-form]');
    var sticky = document.querySelector('[data-stayd-sticky]');
    var submit = root.querySelector('[data-stayd-submit]');

    // Availability is authored into each radio by Liquid. Read it here so the buttons can never
    // offer to add something the shop cannot sell.
    function isAvailable(input) { return input && input.getAttribute('data-available') !== 'false'; }

    function sync() {
      var checked = root.querySelector('.stayd-pack input:checked');
      if (!checked) return;
      var price = checked.getAttribute('data-price');
      var label = checked.getAttribute('data-label');
      var ok = isAvailable(checked);
      var soldText = root.getAttribute('data-sold-label') || 'Sold out';

      if (submit) {
        submit.textContent = ok ? 'Add to bag — ' + price : soldText;
        submit.disabled = !ok;
      }
      if (sticky) {
        var b = sticky.querySelector('[data-stayd-sticky-btn]');
        var m = sticky.querySelector('[data-stayd-sticky-meta]');
        var i = sticky.querySelector('[data-stayd-sticky-input]');
        // The capsule keeps showing and just changes its label. Marked with an attribute rather
        // than [disabled] so no theme rule that hides disabled controls can remove it.
        if (b) {
          b.textContent = ok ? 'Add to bag' : soldText;
          b.removeAttribute('disabled');
          b.setAttribute('aria-disabled', ok ? 'false' : 'true');
          b.dataset.sold = ok ? '' : 'true';
        }
        // Price leads, pack size supports it — the button no longer repeats the number.
        if (m) m.innerHTML = '<b>' + price + '</b><span>' + label + '</span>';
        if (i) i.value = checked.value;
      }
    }
    // Never open on a pack that cannot be bought. Liquid is supposed to preselect an available
    // variant, but selected_or_first_available_variant can still hand back a sold-out one
    // (an explicit ?variant=, or "continue selling when out of stock"), which left both buttons
    // reading "Sold out" while other packs were in stock.
    (function preselectAvailable() {
      var checked = root.querySelector('.stayd-pack input:checked');
      if (checked && isAvailable(checked)) return;
      var open = root.querySelector('.stayd-pack input[data-available="true"]') ||
                 Array.prototype.slice.call(root.querySelectorAll('.stayd-pack input'))
                   .filter(function (i) { return i.getAttribute('data-available') !== 'false'; })[0];
      if (open) { open.checked = true; open.disabled = false; }
    })();

    root.addEventListener('change', function (e) { if (e.target.matches('.stayd-pack input')) sync(); });
    sync();

    // ── Add to cart, then hand off to Horizon's own cart drawer ───────────
    // Horizon: <theme-drawer> owns dialog lifecycle; <cart-drawer-component> auto-opens on
    // StandardEvents.cartLinesUpdate where action === 'add'. Drawer contents come from the
    // Section Rendering API. We add via /cart/add.js requesting that section back, morph it
    // in, then call the drawer's public open().

    function sectionIdFor(selector) {
      var comp = document.querySelector(selector);
      var section = comp && comp.closest('.shopify-section');
      return section ? section.id.replace('shopify-section-', '') : null;
    }
    function drawerSectionId() { return sectionIdFor('cart-drawer-component'); }
    // The header carries the bag bubble; re-rendering it is what actually updates the count,
    // since the theme's own count listener keys off an event constant we cannot import.
    function headerSectionId() {
      return sectionIdFor('cart-icon') || sectionIdFor('header-actions') || sectionIdFor('.header');
    }

    function paintSection(id, html) {
      if (!id || !html) return;
      var host = document.getElementById('shopify-section-' + id);
      if (!host) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.getElementById('shopify-section-' + id) || parsed.body.firstElementChild;
      if (fresh) host.innerHTML = fresh.innerHTML;
    }

    function placeTube() {
      var dialog = document.querySelector('theme-drawer dialog, dialog.cart-drawer');
      if (!dialog) return;
      var summary = dialog.querySelector('.cart-drawer__summary, .cart-drawer footer');
      var empty = !summary || dialog.querySelector('.cart-drawer--empty');
      // :has() covers modern browsers; the class is the fallback and also catches the case
      // where the summary exists but has collapsed to nothing.
      dialog.classList.toggle('stayd-no-tube', !!empty);
      if (empty) return;
      dialog.style.setProperty('--stayd-tube-bottom', Math.round(summary.getBoundingClientRect().height) - 18 + 'px');

      // The summary grows when the discount field expands or a line is added, so measuring
      // once on open leaves the tube overlapping. Track it.
      if (!summary.__staydWatch && 'ResizeObserver' in window) {
        summary.__staydWatch = true;
        new ResizeObserver(function () {
          dialog.style.setProperty('--stayd-tube-bottom', Math.round(summary.getBoundingClientRect().height) - 18 + 'px');
        }).observe(summary);
      }
      if (!dialog.__staydWatch && 'MutationObserver' in window) {
        dialog.__staydWatch = true;
        new MutationObserver(function () { requestAnimationFrame(placeTube); })
          .observe(dialog, { childList: true, subtree: true });
      }
    }

    function openThemeDrawer() {
      var comp = document.querySelector('cart-drawer-component');
      var drawer = comp && comp.closest('theme-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); requestAnimationFrame(placeTube); return true; }
      // Drawer disabled in theme settings, or markup absent.
      return false;
    }

    function announce(action) {
      // Header bubble and any other listeners. Both spellings are dispatched because the
      // constant lives in a bundled module we cannot import from here.
      ['cart:lines-update', 'cart:update'].forEach(function (name) {
        var ev = new CustomEvent(name, { bubbles: true, cancelable: false });
        ev.action = action;
        ev.promise = Promise.resolve({ detail: { didError: false } });
        document.dispatchEvent(ev);
      });
    }

    // Belt and braces for the bag bubble: read the authoritative count and write it in,
    // in case the header markup is not a re-renderable section.
    function bumpCount() {
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Horizon's <cart-icon> exposes renderCartBubble(count) — call it directly rather than
          // trying to reproduce its bubble/animation/sessionStorage bookkeeping by hand.
          var icon = document.querySelector('cart-icon');
          if (icon && typeof icon.renderCartBubble === 'function') {
            icon.renderCartBubble(cart.item_count);
            return;
          }
          // Pre-upgrade fallback: seed the store it reads on connect, then write the text.
          try {
            sessionStorage.setItem('cart-count', JSON.stringify({ value: String(cart.item_count), timestamp: Date.now() }));
          } catch (err) {}
          document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text, [data-cart-count]').forEach(function (el) {
            if (el && el.children.length === 0) el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    }

    var adding = false;
    function addToCart(btn) {
      if (adding) return;
      var checked = root.querySelector('.stayd-pack input:checked');
      if (!checked || !form) return;
      if (!isAvailable(checked)) { sync(); return; }
      adding = true;
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var sectionId = drawerSectionId();
      var headerId = headerSectionId();
      var wanted = [sectionId, headerId].filter(Boolean);
      var payload = { items: [{ id: Number(checked.value), quantity: 1 }] };
      if (wanted.length) payload.sections = wanted;

      function restore() { adding = false; if (btn) { btn.disabled = false; btn.textContent = label; } }

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) {
            var e = new Error('add failed');
            e.status = r.status;          // 422 is Shopify's "not enough items in stock"
            throw e;
          }
          return r.json();
        })
        .then(function (data) {
          // Restore first: everything after this is presentation, and a throw in it must never
          // leave the button reading "Adding…".
          restore();
          try {
            if (data.sections) {
              if (sectionId) paintSection(sectionId, data.sections[sectionId]);
              if (headerId && headerId !== sectionId) paintSection(headerId, data.sections[headerId]);
            }
          } catch (err) {}
          try { announce('add'); } catch (err) {}
          bumpCount();
          if (!openThemeDrawer()) window.location.href = routeRoot + 'cart';
        })
        .catch(function (err) {
          // Never re-submit the form here. Our own capture listener intercepts submit and calls
          // addToCart again, so the old fallback looped and left the button reading "Adding…".
          restore();
          var sold = err && err.status === 422;
          if (sold) {
            if (checked) checked.setAttribute('data-available', 'false');
            sync();
          } else if (btn) {
            btn.textContent = 'Try again';
            setTimeout(sync, 2200);
          }
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        addToCart(root.querySelector('[data-stayd-submit]'));
      }, true);
    }
    root.__staydAdd = addToCart;

    if (sticky) {
      var anchor = root.querySelector('[data-stayd-buy]');
      if (anchor) {
        var update = function () {
          var box = anchor.getBoundingClientRect();
          sticky.classList.toggle('is-visible', box.bottom < 60);
        };
        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
      sticky.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-stayd-sticky-btn]');
        if (btn && btn.dataset.sold === 'true') { e.preventDefault(); return; }
        if (btn) {
          e.preventDefault();
          if (root.__staydAdd) root.__staydAdd(btn);
          else if (form.requestSubmit) form.requestSubmit(); else form.submit();
        }
      });
    }
  }
  function carousel(root) {
    if (root.__staydCarousel) return;
    root.__staydCarousel = true;
    var track = root.querySelector('[data-stayd-track]');
    if (!track) return;
    var prev = root.querySelector('[data-stayd-prev]');
    var next = root.querySelector('[data-stayd-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-stayd-dots] button'));
    var cards = Array.prototype.slice.call(track.children);
    if (!cards.length) return;

    function gap() {
      var g = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
      return isNaN(g) ? 0 : g;
    }
    function step() { return cards[0].offsetWidth + gap(); }
    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function go(left) {
      track.scrollTo({ left: Math.max(0, Math.min(left, maxScroll())), behavior: 'smooth' });
    }
    function active() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestD = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }
    function sync() {
      var i = active();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      root.classList.toggle('is-static', maxScroll() < 4);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll() - 2;
    }
    if (prev) prev.addEventListener('click', function () { go(track.scrollLeft - step()); });
    if (next) next.addEventListener('click', function () { go(track.scrollLeft + step()); });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { go(cards[n].offsetLeft - cards[0].offsetLeft); });
    });
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); });
    window.addEventListener('resize', sync);
    sync();
  }

  function floater(el) {
    var startSel = el.getAttribute('data-start') || '[data-stayd-float-start]';
    var endSel = el.getAttribute('data-end') || '[data-stayd-float-end]';
    var start = document.querySelector(startSel);
    var end = document.querySelector(endSel);
    if (!start || !end) return;
    var raf = null;
    function frame() {
      raf = null;
      var a = start.getBoundingClientRect().top + window.scrollY - window.innerHeight * 0.6;
      var b = end.getBoundingClientRect().bottom + window.scrollY - window.innerHeight * 0.5;
      var y = window.scrollY;
      var on = y > a && y < b;
      el.classList.toggle('is-visible', on);
      var t = Math.max(0, Math.min(1, (y - a) / Math.max(1, b - a)));
      var rot = -14 + t * 28;
      var drift = -30 + t * 60;
      el.style.transform = 'translateY(calc(-50% + ' + drift.toFixed(1) + 'px)) rotate(' + rot.toFixed(1) + 'deg)';
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(frame); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  function orbit(root) {
    if (root.__staydOrbit) return;
    root.__staydOrbit = true;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var scroller = root.querySelector('[data-stayd-orbit-scroll]');
    var stage = root.querySelector('[data-stayd-orbit-stage]');
    var tube = root.querySelector('[data-stayd-orbit-tube]');
    var sheen = root.querySelector('[data-stayd-orbit-sheen]');
    var cue = root.querySelector('[data-stayd-orbit-cue]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-stayd-orbit-item]'));
    var shades = Array.prototype.slice.call(root.querySelectorAll('[data-stayd-orbit-shade] span'));
    if (!scroller || !stage || !tube || !items.length) return;

    // A theme wrapper with overflow-x:hidden/clip turns an ancestor into a scroll container,
    // which makes position:sticky a no-op — the stage scrolls away, the animation runs once
    // and then sits at its end state. Horizon does this on wide viewports, which is why the
    // section froze on desktop but not on mobile. Unclip only the X axis, only on ancestors,
    // only when Y is not itself scrollable.
    (function unclip() {
      var el = root.parentElement;
      while (el && el !== document.body) {
        var cs = getComputedStyle(el);
        var ox = cs.overflowX, oy = cs.overflowY;
        if ((ox === 'hidden' || ox === 'clip') && (oy === 'visible' || oy === 'auto' || oy === 'scroll')) {
          el.style.overflowX = 'visible';
          if (oy === 'auto' || oy === 'scroll') el.style.overflowY = 'visible';
        }
        el = el.parentElement;
      }
    })();

    function sizeTube() {
      var sh = stage.clientHeight || window.innerHeight;
      var img = tube.querySelector('img');
      var cap = Math.min(540, sh * 0.58);
      tube.style.height = Math.round(cap) + 'px';
      tube.style.width = 'auto';
      if (img) { img.style.height = '100%'; img.style.width = 'auto'; }
    }
    sizeTube();

    var n = items.length;

    // Where each feature comes to rest, as a fraction of the stage. Features accumulate:
    // once a bubble arrives it stays, so the final frame shows the whole set around the tube.
    // Side (-1 left / 1 right) and row (-1 up / 0 middle / 1 down). The actual distance is
    // measured from the tube at runtime, so bubbles sit a fixed gap off the object rather than
    // a fraction of the viewport — which is what made them drift far away on wide screens.
    var SLOTS = [[-1, -1], [1, -1], [-1, 0], [1, 0], [-1, 1], [1, 1]];
    var GAP = 26;
    // Each bubble travels for TRAVEL of the scroll, then dwells. Dwelling is what stops you
    // being stranded mid-move: most scroll positions are a settled composition.
    var TRAVEL = 0.30;
    function arrivalOf(i) { return 0.18 + i * (0.74 / Math.max(1, n - 1)); }
    function ease(t) { return 1 - Math.pow(1 - t, 2.4); }

    // Snap markers at each arrival, so a flick lands on a composed frame rather than mid-flight.
    var snapWrap = document.createElement('div');
    snapWrap.className = 'stayd-orbit__snaps';
    var marks = [];
    for (var k = 0; k <= n; k++) {
      var mark = document.createElement('span');
      snapWrap.appendChild(mark);
      marks.push(mark);
    }
    scroller.appendChild(snapWrap);
    function placeMarks() {
      var span = Math.max(1, scroller.offsetHeight - stage.offsetHeight);
      marks.forEach(function (m, i) {
        var at = i < n ? arrivalOf(i) : 1;
        m.style.top = Math.round(at * span) + 'px';
      });
    }
    placeMarks();

    function frame() {
      var box = scroller.getBoundingClientRect();
      var span = Math.max(1, scroller.offsetHeight - stage.offsetHeight);
      var rawP = -box.top / span;
      var p = Math.max(0, Math.min(1, rawP));
      // Snap only while the section owns the screen. Derived from scroll position rather than an
      // observer so it stays correct after programmatic jumps and in embedded contexts.
      document.documentElement.classList.toggle('stayd-snapping', rawP > -0.02 && rawP < 1.02);

      var turn = -13 + p * 26;
      tube.style.transform = 'perspective(1200px) rotateY(' + turn.toFixed(2) + 'deg) rotateZ(' + (turn * 0.16).toFixed(2) + 'deg) scale(' + (1 + Math.sin(p * Math.PI) * 0.035).toFixed(3) + ')';
      if (sheen) sheen.style.transform = 'translateX(' + (-40 + p * 80).toFixed(1) + '%)';
      if (cue) {
        // Stay up for the whole sequence — there is more to scroll until the last feature
        // lands — then fade out only at the very end.
        var cueEnd = arrivalOf(n - 1);
        var cueFade = 0.10;
        cue.style.opacity = p <= cueEnd - cueFade ? 1 : Math.max(0, 1 - (p - (cueEnd - cueFade)) / cueFade).toFixed(2);
      }

      var sw = stage.clientWidth, sh = stage.clientHeight;
      var tubeBox = tube.getBoundingClientRect(), stageBox = stage.getBoundingClientRect();

      var tubeHalf = tubeBox.width / 2;
      var rowGap = Math.min(132, sh * 0.24);
      var edge = 14;
      // Widest a bubble may be if it is to sit BESIDE the tube without touching it or the
      // stage edge. No floor: if the answer is too small, side-by-side genuinely does not fit
      // and we switch layouts rather than silently breaking the guarantee.
      var sideW = sw / 2 - tubeHalf - GAP - edge;
      var stacked = sideW < 150;
      var maxW = stacked ? sw - edge * 2 : sideW;
      root.classList.toggle('is-stacked', stacked);

      items.forEach(function (el, i) {
        try {
        var slot = SLOTS[i % SLOTS.length];
        var arrive = arrivalOf(i);
        var raw = (p - (arrive - TRAVEL)) / TRAVEL;
        var t = Math.max(0, Math.min(1, raw));
        var e = ease(t);

        if (t <= 0) { el.style.opacity = 0; if (shades[i]) shades[i].style.opacity = 0; return; }

        el.style.maxWidth = Math.round(maxW) + 'px';
        var half = el.offsetWidth / 2;
        var restX, restY, dir;
        if (stacked) {
          // Phones: one centred column reading down the tube, bubbles resting over the object.
          // Odd ones sit behind it, so features still pass around the tube rather than beside it.
          restX = 0;
          restY = (i - (n - 1) / 2) * Math.min(74, sh * 0.13);
          dir = i % 2 === 0 ? 1 : -1;
        } else {
          restX = slot[0] * (tubeHalf + GAP + half);
          restY = slot[1] * rowGap;
          dir = -slot[0];
        }
        var sx = restX + (1 - e) * dir * (sw / 2 + el.offsetWidth) * 0.9;
        el.style.zIndex = e > 0.995 ? (stacked && i % 2 === 1 ? 1 : 4) : 6;
        var sy = restY - (1 - e) * 26 * dir;
        var scale = 0.94 + e * 0.06;
        var fade = Math.min(1, t * 1.8);

        el.style.opacity = fade.toFixed(3);
        el.style.transform = 'translate(-50%,-50%) translate3d(' + sx.toFixed(1) + 'px,' + sy.toFixed(1) + 'px,0) scale(' + scale.toFixed(3) + ')';
        // In front while crossing, behind once it has settled to the side.
        el.classList.toggle('stayd-orbit__item--behind', e > 0.995 && stacked && i % 2 === 1);

        var sd = shades[i];
        if (sd) {
          var cx = stageBox.left + sw / 2 + sx, cy = stageBox.top + sh / 2 + sy;
          var near = 1 - Math.min(1, Math.abs(cx - (tubeBox.left + tubeBox.width / 2)) / (tubeBox.width * 1.7));
          sd.style.opacity = (fade * near * 0.95).toFixed(3);
          sd.style.transform = 'translate(' + (cx - tubeBox.left - 75 + 18).toFixed(1) + 'px,' + (cy - tubeBox.top - 48 + 24).toFixed(1) + 'px) scale(' + (0.9 + near * 0.25).toFixed(2) + ')';
        }
        } catch (err) {
          // Never let one bubble strand the rest mid-flight.
          el.style.opacity = 1;
          el.style.transform = 'translate(-50%,-50%)';
        }
      });
    }

    // Ticker rather than scroll listeners: whichever element actually scrolls (window, a theme
    // wrapper, or a smooth-scroll library's own container), reading the rect every frame while
    // the section is on screen is always correct. Costs ~7 transform writes per frame.
    var running = false;
    function tick() {
      if (!running) return;
      frame();
      requestAnimationFrame(tick);
    }
    function start() { if (!running) { running = true; requestAnimationFrame(tick); } }
    function stop() { running = false; }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ent) {
        if (ent[0].isIntersecting) start(); else { stop(); frame(); }
      }, { rootMargin: '300px 0px' }).observe(scroller);
    } else {
      start();
    }
    // Belt and braces for browsers that fire scroll but throttle rAF in background tabs.
    document.addEventListener('scroll', frame, { passive: true, capture: true });
    window.addEventListener('resize', function () { sizeTube(); placeMarks(); frame(); });
    frame();
  }

  function ring(root) {
    var stage = root.querySelector('[data-stayd-ring-stage]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-stayd-ring-card]'));
    if (!stage || !cards.length) return;
    var n = cards.length, step = Math.PI * 2 / n;
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var rot = 0;          // radians
    var vel = 0;          // radians per frame, from the throw
    var IDLE = calm ? 0 : 0.0016;
    var drag = null;

    function place() {
      var rx = Math.min(stage.clientWidth * 0.34, 380);
      var tilt = Math.min(96, stage.clientWidth * 0.10);
      for (var i = 0; i < n; i++) {
        var th = rot + i * step;
        var depth = (Math.cos(th) + 1) / 2;          // 1 = front, 0 = far side
        var scale = 0.34 + depth * 0.66;             // strong falloff
        var x = Math.sin(th) * rx;
        // Tilted disc: the near side dips, the far side rises. Keeps the hub tube readable.
        var y = (depth - 0.5) * tilt;
        var el = cards[i];
        el.style.transform = 'translate(-50%,-50%) translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) scale(' + scale.toFixed(3) + ')';
        el.style.opacity = (0.10 + depth * 0.90).toFixed(3);
        el.style.filter = 'blur(' + ((1 - depth) * 3).toFixed(2) + 'px)';
        el.style.zIndex = Math.round(depth * 100);
      }
    }

    function onFrame() {
      var box = stage.getBoundingClientRect();
      if (box.bottom > -200 && box.top < window.innerHeight + 200) {
        if (!drag) {
          rot += vel;
          vel *= 0.94;
          if (Math.abs(vel) < IDLE) { vel = 0; rot += IDLE; }
        }
        place();
      }
      requestAnimationFrame(onFrame);
    }

    stage.addEventListener('pointerdown', function (e) {
      drag = { x: e.clientX, moved: 0 };
      vel = 0;
      root.classList.add('is-touched');
      stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      drag.x = e.clientX;
      drag.moved += Math.abs(dx);
      var d = dx * 0.006;
      rot += d;
      vel = d;
      place();
    });
    function release() { drag = null; }
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    window.addEventListener('resize', place);

    place();
    requestAnimationFrame(onFrame);
  }

  // ── Force the header solid ───────────────────────────────────────────────
  // The theme setting alone does not hold: Horizon re-applies its transparent
  // treatment from JS on scroll/section-load. Rather than guess the class name,
  // strip anything on the header whose class or attribute says "transparent",
  // and keep stripping it when the theme puts it back.
  (function solidHeader() {
    var group = document.querySelector('.shopify-section-group-header-group') ||
                document.querySelector('header') ||
                document.querySelector('.header');
    if (!group) return;

    // Lift the header above page content. A CSS rule has to guess the theme's wrapper class;
    // this finds the real element — the one that holds the header — and walks up to its
    // section wrapper, because z-index only competes between siblings in the same stacking
    // context. Without this the ring's cards and even its heading paint over the header.
    function raise() {
      var seed = document.querySelector('cart-icon') || document.querySelector('header') || document.querySelector('.header') || group;
      // Stop at the header's own section wrapper. Walking all the way to <body> would also
      // raise a wrapper shared with the page content, which would lift the ring right back up.
      var top = seed.closest('.shopify-section-group-header-group') ||
                seed.closest('.shopify-section') ||
                seed.closest('header') || seed;
      var el = seed;
      while (el) {
        var cs = getComputedStyle(el);
        if (cs.position === 'static') el.style.position = 'relative';
        el.style.zIndex = '900';
        if (el === top) break;
        el = el.parentElement;
      }
    }
    raise();
    document.addEventListener('shopify:section:load', raise);

    function strip(scope) {
      var nodes = [scope].concat(Array.prototype.slice.call(scope.querySelectorAll('*')));
      nodes.forEach(function (el) {
        if (el.classList && el.classList.length) {
          Array.prototype.slice.call(el.classList).forEach(function (c) {
            if (/transparent/i.test(c)) el.classList.remove(c);
          });
        }
        ['transparent', 'data-transparent', 'transparent-header'].forEach(function (a) {
          if (el.hasAttribute && el.hasAttribute(a)) el.removeAttribute(a);
        });
      });
    }
    strip(group);

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t.classList && /transparent/i.test(t.className || '')) { strip(group); return; }
          if (muts[i].type === 'childList') { strip(group); return; }
        }
      });
      mo.observe(group, { attributes: true, attributeFilter: ['class', 'transparent', 'data-transparent'], subtree: true, childList: true });
    }
    document.addEventListener('shopify:section:load', function () { strip(group); });
  })();

  // Ring sections must never outrank the header. Their cards carry depth z-indexes up to 100,
  // so the section gets its own contained stacking context pinned below.
  (function seatRing() {
    document.querySelectorAll('[data-stayd-ring]').forEach(function (el) {
      el.style.position = 'relative';
      el.style.zIndex = '0';
      el.style.isolation = 'isolate';
    });
  })();

  // ── Autoplay ─────────────────────────────────────────────────────────────
  // Horizon lazy-mounts sections, so a video can miss its own autoplay window.
  // Re-assert the attributes browsers actually gate on, then call play() at every
  // point the element becomes ready or visible.
  (function videos() {
    function arm(v) {
      // Arm once. scan() runs again on section:load and first tap, and re-arming stacked a
      // fresh listener set and IntersectionObserver on the same element every time.
      if (v.__staydArmed) return;
      v.__staydArmed = true;

      v.muted = true; v.defaultMuted = true; v.loop = true; v.autoplay = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');

      var go = function () {
        if (!v.paused) return;                 // never call play() on a playing element
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };
      go();
      // NOT 'suspend': that fires when the browser stops fetching, and calling play() from it
      // drives a load/suspend/play loop that stalls the page and leaves the poster showing.
      ['loadeddata', 'canplay'].forEach(function (e) { v.addEventListener(e, go); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { if (en[0].isIntersecting) go(); }).observe(v);
      }
    }
    function scan() {
      document.querySelectorAll('.stayd-hero__media video,.stayd-orbit video,.stayd-how__media video,.stayd-vh-media video,video[autoplay]').forEach(arm);
    }
    scan();
    document.addEventListener('shopify:section:load', scan);
    var once = function () { scan(); document.removeEventListener('click', once); document.removeEventListener('touchstart', once); };
    document.addEventListener('touchstart', once, { passive: true });
    document.addEventListener('click', once);
  })();

  // ── Sticky capsule: reparent to <body> ───────────────────────────────────
  // position:fixed resolves against the nearest ancestor that establishes a containing block —
  // any transform, filter, backdrop-filter, will-change, contain or content-visibility does
  // that. Horizon applies containment to its section wrappers, so the capsule was being
  // positioned inside the hero section's box and sat off-screen at desktop widths. Moving it
  // to <body> (inside a .stayd host, so the brand tokens still resolve) removes the whole
  // class of bug rather than chasing whichever property the theme used this week.
  (function liftSticky() {
    var bar = document.querySelector('[data-stayd-sticky]');
    if (!bar || bar.parentElement === document.body) return;
    var host = document.querySelector('body > .stayd-sticky-host');
    if (!host) {
      host = document.createElement('div');
      host.className = 'stayd stayd-sticky-host';
      document.body.appendChild(host);
    }
    host.appendChild(bar);
  })();

  // ── Sticky capsule: visibility ───────────────────────────────────────────
  // Owned here rather than inside init(), which only ran when the product form resolved.
  // Watches the buy box, falling back to the hero, so the capsule appears on every width.
  (function stickyVisibility() {
    var bar = document.querySelector('[data-stayd-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('[data-stayd-buy]') || document.querySelector('.stayd-hero');
    if (!anchor) return;
    var shown = null;
    function update() {
      var on = anchor.getBoundingClientRect().bottom < 60;
      if (on === shown) return;
      shown = on;
      bar.classList.toggle('is-visible', on);
    }

    // At desktop widths Horizon makes a wrapper the scrolling element, so scroll events never
    // reach window — the same cause as the orbit freezing on desktop. Scroll does not bubble
    // but it does capture, so a capturing listener on document catches whichever element
    // actually scrolls. The rAF ticker is the backstop for smooth-scroll libraries that move
    // content by transform and fire no scroll event at all.
    document.addEventListener('scroll', update, { passive: true, capture: true });
    window.addEventListener('resize', update);
    document.addEventListener('shopify:section:load', update);
    (function tick() { update(); requestAnimationFrame(tick); })();
  })();

  // ── Sticky capsule: pin to the VISUAL viewport ───────────────────────────
  // iOS collapses and restores its toolbar without resizing the layout viewport, so a
  // bottom:0 fixed element drifts up the screen after a scroll down-up-down. visualViewport
  // reports the real visible box; the difference is exactly the overshoot.
  (function pinSticky() {
    var bar = document.querySelector('[data-stayd-sticky]');
    var vv = window.visualViewport;
    if (!bar || !vv) return;
    function place() {
      var gap = window.innerHeight - (vv.height + vv.offsetTop);
      // Only ever a mobile browser toolbar. Clamped so desktop zoom, which also shrinks the
      // visual viewport, can never push the capsule up the page.
      bar.style.setProperty('--stayd-vv-offset', Math.max(0, Math.min(160, Math.round(gap))) + 'px');
    }
    vv.addEventListener('resize', place);
    vv.addEventListener('scroll', place);
    window.addEventListener('orientationchange', function () { setTimeout(place, 260); });
    place();
  })();

  document.querySelectorAll('[data-stayd-compare]').forEach(function (root) {
    var range = root.querySelector('[data-stayd-cmp-range]');
    var after = root.querySelector('[data-stayd-cmp-after]');
    var handle = root.querySelector('[data-stayd-cmp-handle]');
    var tube = root.querySelector('.stayd-cmp-tube');
    if (!range || !after || !handle) return;

    var last = parseFloat(range.value), relax = null;

    function draw() {
      var v = parseFloat(range.value);
      after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
      handle.style.left = v + '%';

      if (tube) {
        // Lean into the direction of travel, then settle back. Gives the drag weight.
        var lean = Math.max(-15, Math.min(15, (v - last) * 1.9));
        tube.style.setProperty('--lean', lean.toFixed(2) + 'deg');
        clearTimeout(relax);
        relax = setTimeout(function () { tube.style.setProperty('--lean', '0deg'); }, 140);
      }
      last = v;
    }

    range.addEventListener('input', draw);

    // Drive the wipe from pointer events on the panel itself. Chrome on Android only drags a
    // range input when the gesture starts on its thumb — touching the track does nothing — so
    // an invisible full-size range works on Safari and fails there. The range stays for
    // keyboard and screen-reader use; touch and mouse come through here.
    var dragging = false;
    function setFromX(clientX) {
      var box = root.getBoundingClientRect();
      if (!box.width) return;
      var pct = ((clientX - box.left) / box.width) * 100;
      range.value = Math.max(0, Math.min(100, pct));
      draw();
    }
    root.addEventListener('pointerdown', function (e) {
      dragging = true;
      root.classList.add('is-dragging', 'is-touched');
      setFromX(e.clientX);
      if (root.setPointerCapture) { try { root.setPointerCapture(e.pointerId); } catch (err) {} }
    });
    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      // Horizontal intent is ours; touch-action:pan-y leaves vertical scrolling to the browser.
      if (e.cancelable) e.preventDefault();
      setFromX(e.clientX);
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
      root.addEventListener(evt, function () {
        dragging = false;
        root.classList.remove('is-dragging');
      });
    });
    range.addEventListener('focus', function () { root.classList.add('is-touched'); });
    draw();
  });

  document.querySelectorAll('[data-stayd-ring]').forEach(ring);
  document.querySelectorAll('[data-stayd-orbit]').forEach(orbit);
  document.querySelectorAll('[data-stayd-pdp]').forEach(init);
  document.querySelectorAll('[data-stayd-carousel]').forEach(carousel);
  document.querySelectorAll('[data-stayd-float]').forEach(floater);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-stayd-pdp]').forEach(init);
    e.target.querySelectorAll('[data-stayd-carousel]').forEach(carousel);
  });

  // ── Ingredients: filter by role ──────────────────────────────────────────
  function ingredients(root) {
    var filters = root.querySelector('[data-stayd-ing-filters]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-stayd-ing-row]'));
    if (!filters || !rows.length) return;

    function apply(role) {
      rows.forEach(function (r) {
        var on = role === 'all' || (r.getAttribute('data-role') || '') === role;
        r.classList.toggle('is-dim', !on);
        r.classList.toggle('is-hit', on && role !== 'all');
      });
      Array.prototype.slice.call(filters.querySelectorAll('button')).forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-role') === role));
      });
    }

    filters.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-role]');
      if (!btn) return;
      // Clicking the active filter clears it, so the list is never stuck filtered.
      var role = btn.getAttribute('aria-pressed') === 'true' ? 'all' : btn.getAttribute('data-role');
      apply(role);
    });
  }
  document.querySelectorAll('[data-stayd-ing]').forEach(ingredients);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-stayd-ing]').forEach(ingredients);
  });

  // Last statement in the file. If "end" never logs, the asset was truncated on upload —
  // which silently kills every section below the cut, not just the one you were editing.
  try { console.info('STAYD PDP build ' + BUILD + ' — end'); } catch (e) {}
})();
